export const AUTOSAVE_TIMEOUT_MS = 1500;
export enum ChecksTimeRange {
  LastDay = 'last day',
  LastThreeDays = 'last three days',
  LastWeek = 'last week',
  LastMonth = 'last month',
}

const ONE_DAY_SECONDS = 60 * 60 * 24;
export const checksTimeRangeInSeconds = {
  [ChecksTimeRange.LastDay]: ONE_DAY_SECONDS,
  [ChecksTimeRange.LastThreeDays]: ONE_DAY_SECONDS * 3,
  [ChecksTimeRange.LastWeek]: ONE_DAY_SECONDS * 7,
  [ChecksTimeRange.LastMonth]: ONE_DAY_SECONDS * 30,
};
export const STATS_TIME_RANGE = ChecksTimeRange.LastMonth;
